import { pagesConfig } from '../../../shared/pages-config';
import { getRuleTemplates } from './rule-templates';
import RuleTemplateCard from './rule-template-card';
import { useNavigate } from 'react-router-dom';
import SimpleBreadcrumbsPage from '../../../shared/simple-breadcrumbs-page';
import { ModuleList } from '../../../shared/analytics/module-list';
import { useUserSettings } from '../../../utils/use-user-settings';
import SharedSvg from '../../../shared/shared-svg';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
export default function RulesEngineBrowseTemplatesPage() {
  const navigate = useNavigate();
  const { features } = useUserSettings();
  const ruleTemplates = getRuleTemplates(features);

  const handleUseTemplate = (templateId: number) => {
    const selectedTemplate = ruleTemplates.find(
      (template) => template.id === templateId
    );
    if (selectedTemplate) {
      navigate(
        `/${pagesConfig.rulesEngine.link}/${pagesConfig.createRule.link}`,
        { state: { template: selectedTemplate, from: 'templates' } }
      );
    }
  };

  return (
    <SimpleBreadcrumbsPage
      breadcrumbs={[
        { label: ModuleList.modules.automation.name },
        {
          label: pagesConfig.rulesEngine.name,
          path: pagesConfig.rulesEngine.link,
        },
      ]}
    >
      <Box sx={{ height: '100%' }}>
        <Card
          sx={{
            width: '100%',
            height: '100%',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box sx={{ p: 1.5, px: 4, flexShrink: 0 }}>
            <Stack direction="row" spacing={1.8} alignItems="center">
              <SharedSvg variant="formAccent" />
              <Typography variant="h5" sx={{ fontWeight: 400 }}>
                {pagesConfig.browseTemplates.name}
              </Typography>
            </Stack>
          </Box>

          <Box sx={{ flex: 1, overflowY: 'auto', p: 4, pt: 2 }}>
            <Grid container spacing={3}>
              {ruleTemplates.map((rule) => (
                <Grid size={{ xs: 12, md: 4 }} key={rule.id}>
                  <RuleTemplateCard
                    rule={rule}
                    onUseTemplate={handleUseTemplate}
                  />
                </Grid>
              ))}
            </Grid>
          </Box>

          <Box sx={{ pl: 2, pb: 2, flexShrink: 0 }}>
            <Button
              variant="outlined"
              sx={{
                color: '#6FC6AC',
                borderColor: '#6FC6AC',
                '&:hover': { borderColor: '#5ca992' },
              }}
              onClick={() => navigate(`/${pagesConfig.rulesEngine.link}`)}
            >
              GO BACK
            </Button>
          </Box>
        </Card>
      </Box>
    </SimpleBreadcrumbsPage>
  );
}
